
import { SavedSignatures } from "@/components/SavedSignatures";
import { SignatureForm } from "@/components/signature/SignatureForm";
import { useSignatures } from "@/hooks/useSignatures";
import { usePendingSignatures } from "@/hooks/usePendingSignatures";
import type { SignatureInputProps } from "@/types/signature";

export const SignatureInput = ({ 
  value, 
  onChange, 
  onSubmit,
  user,
  loading = false,
  style,
  onStyleChange,
}: SignatureInputProps) => {
  const { signatures, deleteSignature } = useSignatures(user);
  const { pendingSignatures, isGenerating } = usePendingSignatures(loading, value);

  const handleSubmit = () => {
    if (!isGenerating && value.trim()) {
      onSubmit();
    }
  };

  return (
    <div className="space-y-8">
      <SignatureForm
        value={value}
        onChange={onChange}
        onSubmit={handleSubmit}
        style={style}
        onStyleChange={onStyleChange}
        disabled={isGenerating}
      />

      <SavedSignatures
        signatures={signatures}
        onDelete={deleteSignature}
        user={user}
        loading={loading}
        pendingSignatures={pendingSignatures}
      />
    </div>
  );
};
